// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for PublicInvoiceView
 * Loads after index.css — wins by source order at equal specificity.
 * Mobile-first additions via max-width breakpoints.
 * Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px
 */

/* ─── TABLET (577–991px) ─────────────────────────────────────────── */
@media (max-width: 991px) {
  .invoice-info-bar {
    grid-template-columns: repeat(2, 1fr);
    padding: 1.25rem 1.5rem;
  }

  .bill-to-section {
    grid-template-columns: 1fr;
    gap: 1.25rem;
    padding: 1.25rem 1.5rem;
  }

  .line-items-section {
    padding: 1.25rem 1.5rem;
  }

  .transactions-section {
    padding: 1.25rem 1.5rem;
  }

  .action-section {
    padding: 1.5rem;
  }

  .invoice-header {
    padding: 1.25rem 1.5rem;
  }

  .invoice-footer {
    padding: 1rem 1.5rem;
  }
}

/* ─── MOBILE (≤576px) ────────────────────────────────────────────── */
@media (max-width: 576px) {
  /* Page background — no top centering so content starts at the top */
  .public-invoice-page {
    padding: 0;
    align-items: flex-start;
    min-height: 100vh;
    min-height: 100dvh; /* dynamic viewport on mobile browsers */
  }

  /* Card container fills the screen, flat on mobile */
  .invoice-container {
    border-radius: 0;
    max-height: none;
    box-shadow: none;
    min-height: 100vh;
    min-height: 100dvh;
  }

  /* Loading / error states also fill screen */
  .loading-state,
  .error-state {
    border-radius: 0;
    max-width: 100%;
    padding: 3rem 1.5rem;
    min-height: 100vh;
    min-height: 100dvh;
    box-shadow: none;
  }

  .error-state h2 {
    font-size: 1.4rem;
  }

  /* Header: logo left, badge right — keep flex but allow wrap */
  .invoice-header {
    padding: 1rem 1.25rem;
    flex-wrap: unset;
    gap: 0.75rem;
  }

  .brand img {
    max-width: 140px;
  }

  /* Info bar: 2-col on mobile (Invoice# + Issue, Due + Amount) */
  .invoice-info-bar {
    grid-template-columns: repeat(2, 1fr);
    padding: 1rem 1.25rem;
    gap: 0.875rem;
  }

  /* Amount due: full row on mobile for readability */
  .info-item.amount-due {
    grid-column: 1 / -1;
  }

  .info-item.amount-due .amount {
    font-size: 2rem;
  }

  /* Bill-to & description */
  .bill-to-section {
    grid-template-columns: 1fr;
    padding: 1rem 1.25rem;
    gap: 1rem;
  }

  /* ── Line items table → card view ──────────────────────────────── */
  .line-items-section {
    padding: 1rem 1.25rem;
  }

  /* Hide the <thead> on mobile — labels come from data-label */
  .piv-items-table-wrap .items-table thead {
    display: none;
  }

  /* Each row becomes a card */
  .piv-items-table-wrap .items-table tbody {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .piv-items-table-wrap .items-table tr {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.25rem 0.75rem;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 0.875rem 1rem;
  }

  /* First cell (Description) spans full width */
  .piv-items-table-wrap .items-table tr td:first-child {
    grid-column: 1 / -1;
    font-weight: 600;
    color: #1f2937;
    font-size: 0.95rem;
    border-bottom: none;
    padding: 0 0 0.5rem 0;
  }

  /* Remaining cells: label above value */
  .piv-items-table-wrap .items-table td {
    display: flex;
    flex-direction: column;
    padding: 0;
    border-bottom: none;
    font-size: 0.875rem;
    text-align: left !important; /* override col-right / col-center */
  }

  .piv-items-table-wrap .items-table td::before {
    content: attr(data-label);
    font-size: 0.65rem;
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.2rem;
  }

  /* ── Totals ─────────────────────────────────────────────────────── */
  .totals-section {
    align-items: stretch;
  }

  /* Undo the hardcoded width: 250px / 280px from the inline styles block */
  .total-row {
    width: 100% !important;
  }

  .total-row.remaining,
  .total-row.overpaid-row {
    width: 100% !important;
    box-sizing: border-box;
  }

  /* ── Transactions table → card view ─────────────────────────────── */
  .transactions-section {
    padding: 1rem 1.25rem;
  }

  .piv-tx-table-wrap .transactions-table thead {
    display: none;
  }

  .piv-tx-table-wrap .transactions-table tbody {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .piv-tx-table-wrap .transactions-table tr {
    display: grid;
    grid-template-columns: unset;
    gap: 0.25rem 0.75rem;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 0.875rem 1rem;
  }

  /* Date spans full width as card "header" */
  .piv-tx-table-wrap .transactions-table tr td:first-child {
    grid-column: 1 / -1;
    font-weight: 600;
    color: #374151;
    font-size: 0.85rem;
    border-bottom: none;
    padding: 0 0 0.5rem 0;
  }

  .piv-tx-table-wrap .transactions-table td {
    display: flex;
    flex-direction: column;
    padding: 0;
    border-bottom: none;
    font-size: 0.85rem;
    gap: 10px;
  }

  .piv-tx-table-wrap .transactions-table td::before {
    content: attr(data-label);
    font-size: 0.65rem;
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.2rem;
  }

  /* ── Action section: full-width stacked buttons ─────────────────── */
  .action-section {
    flex-direction: column;
    padding: 1.25rem 1.25rem calc(1.25rem + env(safe-area-inset-bottom));
    gap: 0.75rem;
  }

  .btn-pay,
  .btn-download {
    width: 100%;
    justify-content: center;
    min-height: 52px; /* touch target >= 44px */
    font-size: 1rem;
    padding: 0.875rem 1.5rem;
  }

  /* Footer */
  .invoice-footer {
    padding: 1rem 1.25rem calc(1rem + env(safe-area-inset-bottom));
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/PublicInvoiceView.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,uEAAuE;AACvE;EACE;IACE,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,uEAAuE;AACvE;EACE,oEAAoE;EACpE;IACE,UAAU;IACV,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB,EAAE,wCAAwC;EAC9D;;EAEA,oDAAoD;EACpD;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,4CAA4C;EAC5C;;IAEE,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,8DAA8D;EAC9D;IACE,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA,+DAA+D;EAC/D;IACE,qCAAqC;IACrC,qBAAqB;IACrB,aAAa;EACf;;EAEA,mDAAmD;EACnD;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA,0BAA0B;EAC1B;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,SAAS;EACX;;EAEA,qEAAqE;EACrE;IACE,qBAAqB;EACvB;;EAEA,6DAA6D;EAC7D;IACE,aAAa;EACf;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA,8CAA8C;EAC9C;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA,uCAAuC;EACvC;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B,EAAE,oCAAoC;EACnE;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA,sEAAsE;EACtE;IACE,oBAAoB;EACtB;;EAEA,yEAAyE;EACzE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA,sEAAsE;EACtE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,4BAA4B;IAC5B,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA,2CAA2C;EAC3C;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA,sEAAsE;EACtE;IACE,sBAAsB;IACtB,oEAAoE;IACpE,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,uBAAuB;IACvB,gBAAgB,EAAE,yBAAyB;IAC3C,eAAe;IACf,wBAAwB;EAC1B;;EAEA,WAAW;EACX;IACE,8DAA8D;EAChE;AACF","sourcesContent":["/*\n * Responsive overrides for PublicInvoiceView\n * Loads after index.css — wins by source order at equal specificity.\n * Mobile-first additions via max-width breakpoints.\n * Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px\n */\n\n/* ─── TABLET (577–991px) ─────────────────────────────────────────── */\n@media (max-width: 991px) {\n  .invoice-info-bar {\n    grid-template-columns: repeat(2, 1fr);\n    padding: 1.25rem 1.5rem;\n  }\n\n  .bill-to-section {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n    padding: 1.25rem 1.5rem;\n  }\n\n  .line-items-section {\n    padding: 1.25rem 1.5rem;\n  }\n\n  .transactions-section {\n    padding: 1.25rem 1.5rem;\n  }\n\n  .action-section {\n    padding: 1.5rem;\n  }\n\n  .invoice-header {\n    padding: 1.25rem 1.5rem;\n  }\n\n  .invoice-footer {\n    padding: 1rem 1.5rem;\n  }\n}\n\n/* ─── MOBILE (≤576px) ────────────────────────────────────────────── */\n@media (max-width: 576px) {\n  /* Page background — no top centering so content starts at the top */\n  .public-invoice-page {\n    padding: 0;\n    align-items: flex-start;\n    min-height: 100vh;\n    min-height: 100dvh; /* dynamic viewport on mobile browsers */\n  }\n\n  /* Card container fills the screen, flat on mobile */\n  .invoice-container {\n    border-radius: 0;\n    max-height: none;\n    box-shadow: none;\n    min-height: 100vh;\n    min-height: 100dvh;\n  }\n\n  /* Loading / error states also fill screen */\n  .loading-state,\n  .error-state {\n    border-radius: 0;\n    max-width: 100%;\n    padding: 3rem 1.5rem;\n    min-height: 100vh;\n    min-height: 100dvh;\n    box-shadow: none;\n  }\n\n  .error-state h2 {\n    font-size: 1.4rem;\n  }\n\n  /* Header: logo left, badge right — keep flex but allow wrap */\n  .invoice-header {\n    padding: 1rem 1.25rem;\n    flex-wrap: unset;\n    gap: 0.75rem;\n  }\n\n  .brand img {\n    max-width: 140px;\n  }\n\n  /* Info bar: 2-col on mobile (Invoice# + Issue, Due + Amount) */\n  .invoice-info-bar {\n    grid-template-columns: repeat(2, 1fr);\n    padding: 1rem 1.25rem;\n    gap: 0.875rem;\n  }\n\n  /* Amount due: full row on mobile for readability */\n  .info-item.amount-due {\n    grid-column: 1 / -1;\n  }\n\n  .info-item.amount-due .amount {\n    font-size: 2rem;\n  }\n\n  /* Bill-to & description */\n  .bill-to-section {\n    grid-template-columns: 1fr;\n    padding: 1rem 1.25rem;\n    gap: 1rem;\n  }\n\n  /* ── Line items table → card view ──────────────────────────────── */\n  .line-items-section {\n    padding: 1rem 1.25rem;\n  }\n\n  /* Hide the <thead> on mobile — labels come from data-label */\n  .piv-items-table-wrap .items-table thead {\n    display: none;\n  }\n\n  /* Each row becomes a card */\n  .piv-items-table-wrap .items-table tbody {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .piv-items-table-wrap .items-table tr {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.25rem 0.75rem;\n    background: #f9fafb;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 0.875rem 1rem;\n  }\n\n  /* First cell (Description) spans full width */\n  .piv-items-table-wrap .items-table tr td:first-child {\n    grid-column: 1 / -1;\n    font-weight: 600;\n    color: #1f2937;\n    font-size: 0.95rem;\n    border-bottom: none;\n    padding: 0 0 0.5rem 0;\n  }\n\n  /* Remaining cells: label above value */\n  .piv-items-table-wrap .items-table td {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n    border-bottom: none;\n    font-size: 0.875rem;\n    text-align: left !important; /* override col-right / col-center */\n  }\n\n  .piv-items-table-wrap .items-table td::before {\n    content: attr(data-label);\n    font-size: 0.65rem;\n    font-weight: 600;\n    color: #9ca3af;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin-bottom: 0.2rem;\n  }\n\n  /* ── Totals ─────────────────────────────────────────────────────── */\n  .totals-section {\n    align-items: stretch;\n  }\n\n  /* Undo the hardcoded width: 250px / 280px from the inline styles block */\n  .total-row {\n    width: 100% !important;\n  }\n\n  .total-row.remaining,\n  .total-row.overpaid-row {\n    width: 100% !important;\n    box-sizing: border-box;\n  }\n\n  /* ── Transactions table → card view ─────────────────────────────── */\n  .transactions-section {\n    padding: 1rem 1.25rem;\n  }\n\n  .piv-tx-table-wrap .transactions-table thead {\n    display: none;\n  }\n\n  .piv-tx-table-wrap .transactions-table tbody {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .piv-tx-table-wrap .transactions-table tr {\n    display: grid;\n    grid-template-columns: unset;\n    gap: 0.25rem 0.75rem;\n    background: white;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 0.875rem 1rem;\n  }\n\n  /* Date spans full width as card \"header\" */\n  .piv-tx-table-wrap .transactions-table tr td:first-child {\n    grid-column: 1 / -1;\n    font-weight: 600;\n    color: #374151;\n    font-size: 0.85rem;\n    border-bottom: none;\n    padding: 0 0 0.5rem 0;\n  }\n\n  .piv-tx-table-wrap .transactions-table td {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n    border-bottom: none;\n    font-size: 0.85rem;\n    gap: 10px;\n  }\n\n  .piv-tx-table-wrap .transactions-table td::before {\n    content: attr(data-label);\n    font-size: 0.65rem;\n    font-weight: 600;\n    color: #9ca3af;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin-bottom: 0.2rem;\n  }\n\n  /* ── Action section: full-width stacked buttons ─────────────────── */\n  .action-section {\n    flex-direction: column;\n    padding: 1.25rem 1.25rem calc(1.25rem + env(safe-area-inset-bottom));\n    gap: 0.75rem;\n  }\n\n  .btn-pay,\n  .btn-download {\n    width: 100%;\n    justify-content: center;\n    min-height: 52px; /* touch target >= 44px */\n    font-size: 1rem;\n    padding: 0.875rem 1.5rem;\n  }\n\n  /* Footer */\n  .invoice-footer {\n    padding: 1rem 1.25rem calc(1rem + env(safe-area-inset-bottom));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
